<template>
  <div>
    <div class="actions">
      <div class="tag">
        <el-tag v-if="hasQueryTag" closable @close="clearQueryTag">{{
          queryTag
        }}</el-tag>
      </div>
      <el-button
        class="main-button"
        size="small"
        @click="$router.push({ name: 'admin_releases_draft' })"
        >草稿</el-button
      >
      <el-button
        class="main-button"
        type="primary"
        size="small"
        @click="createRelease"
        >创建版本</el-button
      >
    </div>
    <div class="mt-10">
      <ReleasesListAdminTable
        showCreatedAt
        showPublishedAt
        :releases="releases"
        @delete="deleteRelease"
      ></ReleasesListAdminTable>
    </div>
    <div class="paging">
      <el-pagination
        @current-change="handlePaginatorPageChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        layout="prev, pager, next, jumper"
        :total="paging.total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { OopsErrorELMessage, ReleasesMixin } from "@/mixins";
import ReleasesListAdminTable from "@/components/ReleasesListAdminTable";
export default {
  name: "Releases",
  mixins: [OopsErrorELMessage, ReleasesMixin],
  components: {
    ReleasesListAdminTable
  },
  created() {
    this.listReleases();
  },
  methods: {
    createRelease() {
      this.$http
        .post("/api/v1/releases", {})
        .then(resp => {
          this.$router.push({
            name: "admin_release_edit",
            params: { release_id: resp.data.id }
          });
        })
        .catch(() => this.oopsError());
    }
  }
};
</script>

<style scoped></style>
